module.exports = __webpack_public_path__ + "img/git.aa4a6709.svg";